import {Injectable} from '@angular/core';
import {GroupConfig, GroupConfigs} from '../../shared/models/config';

@Injectable({
  providedIn: 'root'
})
export class GetConfigInvoicesService {

  constructor() {
  }
  getConfigTriggerInvoices(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'GENERIC_START_DATE',
          controlName: ['start', 'id'],
          placeholder: 'GENERIC_START_DATE',
          data: 'invoicesYears',
          options: {
            value: 'id',
            vue: 'name',
            show: true,
            labelShowInDetail: true,
            allowOptionEmpty: false,
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'INVOICES_TRIGGER_PERIOD',
          controlName: ['CalculationGenerationType', 'id'],
          placeholder: 'INVOICES_TRIGGER_PERIOD',
          data: 'PeriodType',
          options: {
            value: 'id',
            vue: 'name',
            show: true,
            labelShowInDetail: true,
          },
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'GENERIC_OFFICES',
          controlName: ['offices'],
          placeholder: '1,4',
          presentation: 'edit',
          options: {
            show: true
          }
        }
      ]
    }
  };
  getConfigInvoicesDetails1(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_INVOICE_NUMBER',
          controlName: ['number'],
          placeholder: 'GENERIC_INVOICE_NUMBER',
          presentation: 'detail',
          options: {
            show: false,
            split: true,
            splitChar: ',',
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CODE',
          controlName: ['invoiceCode'],
          placeholder: 'GENERIC_CODE',
          presentation: 'detail',
          options: {
            show: true
          }
        },
      ]
    }
  };
  getConfigInvoicesDetails(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigInvoicesDetails1(),
        this.getConfigInvoicesDetails2(),
        this.getConfigInvoicesDetails3(),
      ]
    }
  }
  getConfigInvoicesDetails2(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_COMPANY_NAME',
          controlName: ['companyName'],
          placeholder: 'GENERIC_COMPANY_NAME',
          presentation: 'detail',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_TOTAL',
          controlName: ['invoiceTotal'],
          placeholder: 'GENERIC_TOTAL',
          presentation: 'detail',
          options: {
            show: true,
            unit: '€',
            shortInput: true
          }
        },
      ]
    }
  };
  getConfigInvoicesDetails3(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_INVOICES_DETAIL_SAP_INVOICES_TOTAL',
          controlName: ['sapInvoiceTotal'],
          placeholder: 'GENERIC_INVOICES_DETAIL_SAP_INVOICES_TOTAL',
          presentation: 'detail',
          options: {
            show: true,
            unit: '€',
            shortInput: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_INVOICES_DETAIL_SALES_FORCE_ID',
          controlName: ['sfCustomerOrderID'],
          placeholder: 'GENERIC_INVOICES_DETAIL_SALES_FORCE_ID',
          presentation: 'detail',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_INVOICES_DETAIL_SYNC_DATE',
          controlName: ['sfSynchronizationDate'],
          placeholder: 'GENERIC_INVOICES_DETAIL_SYNC_DATE',
          presentation: 'detail',
          options: {
            show: true
          }
        },
      ]
    }
  };
  getConfigValidationInvoices(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'GENERIC_START_DATE',
          controlName: ['date'],
          placeholder: 'GENERIC_START_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
          presentation: 'edit'
        }
      ]
    }
  };
  getHistoryFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigFilterHistoryInvoices()
      ]
    }
  }
  getInvoicesDetailFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigFilterInvoicesDetail()
      ]
    }
  }
  getConfigFilterInvoicesDetail(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_CODE',
          controlName: ['code'],
          placeholder: 'GENERIC_CODE',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_INVOICES_DETAIL_LIST_LOGISTICS_CODE',
          controlName: ['logisticCode'],
          placeholder: 'GENERIC_INVOICES_DETAIL_LIST_LOGISTICS_CODE',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_NAME',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CONTRACT_NAME',
          controlName: ['contract'],
          placeholder: 'GENERIC_CONTRACT_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          controlName: ['productId', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          data: 'product',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigFilterHistoryInvoices(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_DATE',
          controlName: ['date'],
          placeholder: 'GENERIC_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_STATUS',
          data: 'invoicesHistoryStatus',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'filter'
        },
        // {
        //   type: 'datePicker',
        //   label: 'INVOICES_HISTORY_STARTED',
        //   controlName: ['started'],
        //   placeholder: 'INVOICES_HISTORY_STARTED',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     datePicker: {
        //       useCurrent: false,
        //       defaultDate: null,
        //     }
        //   },
        //   presentation: 'filter'
        // },
        // {
        //   type: 'datePicker',
        //   label: 'INVOICES_HISTORY_COMPLETED',
        //   controlName: ['completed'],
        //   placeholder: 'INVOICES_HISTORY_COMPLETED',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     datePicker: {
        //       useCurrent: false,
        //       defaultDate: null,
        //     }
        //   },
        //   presentation: 'filter'
        // },
        {
          type: 'select',
          label: 'CONTRACT_FORM_RECURRENCE',
          controlName: ['recurrence', 'id'],
          placeholder: 'CONTRACT_FORM_RECURRENCE',
          data: 'recurrence',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'filter'
        },
        // {
        //   type: 'select',
        //   label: 'GENERIC_ADJUSTMENT',
        //   controlName: ['adjustment', 'id'],
        //   placeholder: 'GENERIC_ADJUSTMENT',
        //   data: 'invoicesHistoryAdjustment',
        //   options: {
        //     show: true,
        //     value: 'id',
        //     vue: 'name',
        //     labelShowInDetail: false
        //   },
        //   presentation: 'filter'
        // },
        // {
        //   type: 'datePicker',
        //   label: 'GENERIC_CREATED',
        //   controlName: ['created'],
        //   placeholder: 'GENERIC_CREATED',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     datePicker: {
        //       useCurrent: false,
        //       defaultDate: null,
        //     }
        //   },
        //   presentation: 'filter'
        // },
      ]
    }
  }

  getFirstDayOfEachMonth(): string [] {
   const year = new Date().getFullYear();
   return ['01/01/' + (year - 1), '02/01/' + (year - 1), '03/01/' + (year - 1),
           '04/01/' + (year - 1), '05/01/' + (year - 1), '06/01/' + (year - 1),
           '07/01/' + (year - 1), '08/01/' + (year - 1), '09/01/' + (year - 1),
           '10/01/' + (year - 1), '11/01/' + (year - 1), '12/01/' + (year - 1),
           '01/01/' + year, '02/01/' + year, '03/01/' + year,
           '04/01/' + year, '05/01/' + year, '06/01/' + year,
           '07/01/' + year, '08/01/' + year, '09/01/' + year,
           '10/01/' + year, '11/01/' + year, '12/01/' + year,
           '01/01/' + (year + 1), '02/01/' + (year + 1), '03/01/' + (year + 1),
           '04/01/' + (year + 1), '05/01/' + (year + 1), '06/01/' + (year + 1),
           '07/01/' + (year + 1), '08/01/' + (year + 1), '09/01/' + (year + 1),
           '10/01/' + (year + 1), '11/01/' + (year + 1), '12/01/' + (year + 1)]
  }
}
